// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  // 瀏覽次數
  LoadViewCount(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/LoadViewCount',
      params,
    });
  },
  // 整體表現
  LoadResPercent(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/LoadResPercent',
      params,
    });
  },
  // 輔導項目紀錄
  LoadResRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/LoadResRecord',
      params,
    });
  },
  // 匯出輔導項目紀錄
  ExportResRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/ExportResRecord',
      responseType: 'blob',
      params,
    });
  },
  LoadRegistRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/LoadRegistRecord',
      params,
    });
  },
  ExportRegistRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/ExportRegistRecord',
      responseType: 'blob',
      params,
    });
  },
  LoadQueSurveyRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/LoadQueSurveyRecord',
      params,
    });
  },
  ExportQueSurveyRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/ExportQueSurveyRecord',
      responseType: 'blob',
      params,
    });
  },
  LoadSatisfactionRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/LoadSatisfactionRecord',
      params,
    });
  },
  ExportSatisfactionRecord(params) {
    return defaultApi({
      method: 'get',
      url: 'Report/ExportSatisfactionRecord',
      responseType: 'blob',
      params,
    });
  },
};
